import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { indexOf } from 'lodash';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';
import getMenus from './menus';

import {
  getUser, getIsSuperAdmin, getIsAdmin, getIsPIUser,
  getUserCurrentOrganization,
} from '../../../Auth/AuthReducer';

class FeedbackNav extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      user, userCurrentOrganization,
      canSeeAllPages,
    } = this.props;
    const menus = getMenus(user, userCurrentOrganization, canSeeAllPages);
    if (menus && menus.length) {
      return (
        <ul className="nav nav-tabs">
          {menus.map(menu => (
            <LinkContainer exact key={menu.key} to={menu.slug}>
              <NavItem>{menu.label}</NavItem>
            </LinkContainer>
          ))}
        </ul>
      );
    }
    return null;
  }
}

function mapStateToProps(state) {
  const isAdmin = getIsAdmin(state);
  const isSuperAdmin = getIsSuperAdmin(state);
  const isPIUser = getIsPIUser(state);
  const userCurrentOrganization = getUserCurrentOrganization(state);
  const user = getUser(state);
  let canSeeAllPages = false;
  if (isAdmin || isSuperAdmin) {
    canSeeAllPages = true;
  } else if (isPIUser && user && userCurrentOrganization && indexOf(user.organization__ids, userCurrentOrganization._id) >= 0) {
    canSeeAllPages = true;
  }

  return {
    user,
    canSeeAllPages,
    userCurrentOrganization,
  };
}


FeedbackNav.propTypes = {
  canSeeAllPages: PropTypes.bool,
  user: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    organization_role: PropTypes.string.isRequired,
  }).isRequired,
  userCurrentOrganization: PropTypes.shape({
    role_access_rules: PropTypes.shape({}).isRequired,
    features: PropTypes.shape({}).isRequired,
  }).isRequired,
};
FeedbackNav.defaultProps = {
  canSeeAllPages: false,
};

FeedbackNav.contextTypes = {
  router: PropTypes.shape({}),
};


export default withRouter(connect(mapStateToProps)(FeedbackNav));
